import { Box } from '@factorialco/deprecated-design-system'

import { NavigateToCompensation } from 'modules/finance/components/FinancialWorkspaceCompensations/components/NavigateToCompensation'

export const Header = () => {
  return (
    <Box gap="s12">
      <Box flexDirection="row" gap="s24" justifyContent="flexEnd">
        <Box flexDirection="column">
          <NavigateToCompensation />
        </Box>
      </Box>
    </Box>
  )
}
